<template lang="pug">
    section.abonement
        el-row
            el-col.col-left(:lg="12" :md="12")
                .groups
                    transition-group(name="slide-decent-vertical")
                        .row(
                            v-for="(group, i) in groups" :key="i"
                            v-if="checkConditions(group)"
                        )
                            transition-group.flex(name="slide-decent-vertical")
                                SettingField.setting-field(
                                    v-for="field in group.fields"
                                    v-if="checkConditions(field)"
                                    :key="field.key"
                                    :field="field"
                                    :setting-values="settingValues"
                                )
                el-collapse(accordion v-if="blocks && blocks.length")
                    transition-group(name="slide-decent-vertical")
                        el-collapse-item(
                            v-for="block in blocks" :key="block.key"
                            v-if="checkConditions(block)"
                            :name="block.key"
                        )
                            template(slot="title")
                                FontAwesomeIcon.icon(v-if="block.icon" :icon="block.icon")
                                span {{ block.name }}
                            transition-group(name="slide-decent-vertical")
                                .row(
                                    v-for="(group, i) in block.groups" :key="i"
                                    v-if="checkConditions(group)"
                                )
                                    transition-group.flex(name="slide-decent-vertical")
                                        SettingField.setting-field(
                                            v-for="field in group.fields"
                                            v-if="checkConditions(field)"
                                            :key="field.key"
                                            :field="field"
                                            :setting-values="settingValues"
                                        )
            el-col.col-right(:lg="12" :md="12")
                template(v-for="image in images")
                    img(v-if="image.url && checkConditions(image)" :src="image.url")
</template>

<script>

import _ from 'lodash'
import SettingField from './Partials/SettingField'
import pinia from '@/pinia'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { useSettingsStore, useSetupStore, usePageStore } from '@/stores'

export default {
    name: 'AbonementDesign',
    components: {
        SettingField,
        FontAwesomeIcon
    },
    computed: {
        settings() {
            const settings = _.get(this.form, 'config.template.settings') || []
            return settings.find(el => el.key === 'design')
        },
        images() {
            return _.get(this.settings, 'images') || []
        },
        blocks() {
            return _.get(this.settings, 'blocks') || []
        },
        groups() {
            return _.get(this.settings, 'groups') || []
        },

        form() {
            return useSettingsStore().form;
        },
        settingValues() {
            return useSettingsStore().values;
        },
        options() {
            return useSettingsStore().options;
        },
        activeCms() {
            return useSetupStore().activeCms;
        },
        enabledExtensions() {
            return useSetupStore().enabledExtensions;
        },
        enabledFeatures() {
            return useSetupStore().enabledFeatures;
        },
        pageStore() {
            return usePageStore();
        }
    },
    methods: {
        checkConditions(setting) {
            let valid = true

            // eslint-disable-next-line no-unused-vars
            const settings = this.settingValues;
            // eslint-disable-next-line no-unused-vars
            const enabledExtensions = this.enabledExtensions;
            // eslint-disable-next-line no-unused-vars
            const enabledFeatures = this.enabledFeatures;
            try {
                const conditions = setting.conditions
                if (conditions && conditions.length) {
                    conditions.forEach(o => {
                        if (valid === false) return

                        const { type, condition } = o
                        switch (type) {
                            case 'eval':
                                valid = eval(condition)
                                break;

                            default:
                                valid = false
                        }
                    })
                }
            } catch (error) {
                // eslint-disable-next-line
                console.error(error);
                valid = false
            }

            return valid
        },
        // isVisible(key) {
        //     if (key.includes("menu")) {
        //         let itemKey = key + '-isactive'
        //         return this.form.settings.find((item) => item.key == itemKey && item.template_key == this.form.config.template.id).value === 'true'
        //     }
        //     else {
        //         return true
        //     }
        // },
        // updateValue: function (event, key) {
        //     let value;
        //     const template_key = this.form.config.template.id
        //     var index = this.form.settings.findIndex(function (item, i) {
        //         return item.key.toString() === key && item.template_key.toString() === template_key
        //     });

        //     if (index >= 0) {
        //         value = value === true ? "true" : "false";
        //     }
        //     store.commit(`settings/form/setSetting`, { index, value: event.toString() });
        // }
        fetchMenuOptions(cmsID) {
            return this.pageStore.fetchMenuOptions(cmsID);
        }
    },
    beforeRouteEnter(to, from, next) {
        let cms = useSetupStore(pinia).activeCms;

        next(vm => {
            const settings = _.get(vm.form, 'config.template.settings')
                || _.get(vm.activeCms, 'config.template.settings')
                || []

            if (!settings.find(el => el.key === 'design')) {
                next({ name: 'settings-form' });
            } else {
                next();
            }
        })
    },
    mounted() {
        this.fetchMenuOptions(this.activeCms.id)
    }
}
</script>

<style lang="sass" scoped>
.row
    display: flex
    margin-bottom: 12px
    & > span.flex
        width: 100%
        display: flex
        flex-wrap: wrap
        row-gap: 20px

.setting-field
    margin-right: 20px

.col-right
    img
        width: 90%

.el-main.main-slot .el-form .el-card .el-card__body section > .el-row > .el-col-lg-12:first-child:before
    display: none

.icon
    margin-right: 10px
</style>
